<template>
  <div>
    <v-card style="background: antiquewhite">
      <v-card-text class="d-flex-initial d-flex align-center">
        <v-icon class="mr-2">info</v-icon>
        Vous pouvez voir ici l'évolution de votre projet. .</v-card-text
      >
    </v-card>
    <v-card>
      <v-timeline align-top dense class="ml-2 mt-3">
        <ProjectTimelineItem
          v-for="item in items"
          :item="item"
          :key="item._id"
          @delete="deleteItem(item)"
        />

        <v-timeline-item color="grey lighten-3" small>
          <v-layout pt-3>
            <v-flex xs2>
              <strong>{{ createdAt | shortDate }}</strong>
            </v-flex>
            <v-flex>
              <strong>Création du projet</strong>
            </v-flex>
          </v-layout>
        </v-timeline-item>
      </v-timeline>
    </v-card>
  </div>
</template>

<script>
import { fetchHil, objectIdToDate } from "../../utils";
import ProjectTimelineItem from "./ProjectTimelineItem";
import moment from "moment";

export default {
  components: { ProjectTimelineItem },
  props: ["id"],
  data() {
    return {
      items: []
    };
  },
  async mounted() {
    this.reload();
  },

  computed: {
    createdAt() {
      const projectId = this.id;
      return objectIdToDate(projectId);
    }
  },

  methods: {
    async reload() {
      const projectId = this.id;
      const resp = await fetchHil(`/timeline/for/${projectId}`);
      if (resp.ok) {
        const items = await resp.json();
        this.items = items
          .filter(item => {
            return (
              item.type !== "FEEDBACK" ||
              typeof item.params.sponsor === "boolean"
            );
          })
          .sort((a, b) => {
            return moment(a.date).isBefore(b.date) ? 1 : -1;
          });
      }
    }
  },

  watch: {
    id: newVal => {
      this.items = [];
      this.reload(newVal);
    }
  }
};
</script>
